import { Box } from "@mui/material";

import WhatsAppIcon from "@assets/img/WhatsAppIcon.svg";

const WhatsAppButton = () => {
  const phoneNumber = import.meta.env.VITE_SUPPORT_PHONE_NUMBER;

  if (!phoneNumber) return null;

  return (
    <Box
      component="a"
      href={`https://api.whatsapp.com/send/?phone=52${phoneNumber}&text&type=phone_number&app_absent=0`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Soporte por WhatsApp"
      sx={{
        position: "fixed",
        bottom: "22px",
        right: "24px",
        zIndex: 50,
        transition: "transform 0.3s",
        "&:hover": {
          transform: "scale(1.1)",
        },
      }}
    >
      <Box
        component="img"
        src={WhatsAppIcon}
        alt="Soporte por WhatsApp"
        sx={{
          width: 50,
          height: 50,
          filter: "drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1))",
          willChange: "transform",
        }}
      />
    </Box>
  );
};

export default WhatsAppButton;
